import { IUIStore } from '../interface/IUIStore';
import { Store } from './Store';

export abstract class UIStore extends Store implements IUIStore {}
